import { Placement } from "./Placement";
import Sprite from "../components/object-graphics/Sprite";
import { TILES } from "../helpers/tiles";

export class SwitchableWallPlacement extends Placement {
  constructor(properties, level) {
    super(properties, level);
    this.isRaised = properties.isRaised;
    this.jsonSavingOverrides.isRaised = this.isRaised; // Persist this on map save
  }

  //Would be called when a switch is stepped on
  toggleRaised() {
    this.isRaised = !this.isRaised;
  }

  isSolid() {
    return this.isRaised;
  }

  renderComponent() {
    return (
      <Sprite
        frameCoord={
          this.isRaised ? TILES.PURPLE_DOOR_SOLID : TILES.PURPLE_DOOR_OUTLINE
        }
      />
    );
  }
}
